export default {
    'UNSAVED_CHANGES_MESSAGE': 'Leave site? Changes that you made may not be saved.'
}


// WEBPACK FOOTER //
// ./src/translations/en.js